import React, { memo, useEffect, useMemo, useState } from 'react';
import { Chip, Stack } from 'investira.react.components';

const Range = memo(props => {
  const {
    min = -3,
    max = 3,
    step = 0.5,
    value,
    defaultValue = -3,
    onChange,
    size = 'small'
  } = props;

  const isControlled = typeof value === 'number';
  const [selectedValue, setSelectedValue] = useState(defaultValue);

  const options = useMemo(() => {
    const xOptions = [];

    for (let xValue = min; xValue <= max + 1e-9; xValue += step) {
      xOptions.push(Number(xValue.toFixed(1)));
    }

    return xOptions;
  }, [max, min, step]);

  useEffect(() => {
    if (isControlled) {
      setSelectedValue(value);
    }
  }, [isControlled, value]);

  const formatLabel = pValue => {
    const xIsInteger = Number.isInteger(pValue);
    const xValue = xIsInteger ? pValue.toString() : pValue.toFixed(1);

    return xValue.replace('.', ',');
  };

  const handleSelect = pValue => {
    if (!isControlled) {
      setSelectedValue(pValue);
    }

    onChange && onChange(pValue);
  };

  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        flexWrap: 'nowrap',
        overflowX: 'auto',
        py: 0.5,
        '& .MuiChip-root': {
          flexShrink: 0
        }
      }}>
      {options.map(xOption => {
        const xSelected = xOption === selectedValue;

        return (
          <Chip
            key={`range-${xOption}`}
            label={formatLabel(xOption)}
            size={size}
            color={'primary'}
            variant={xSelected ? 'filled' : 'outlined'}
            sx={{
              minWidth: 44,
              justifyContent: 'center'
            }}
            clickable
            onClick={() => handleSelect(xOption)}
          />
        );
      })}
    </Stack>
  );
});

export default Range;
